var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('News-List',{attrs:{"data":_vm.Notice}}),_c('Pagination',{attrs:{"pageNo":_vm.naml.page,"pageSize":_vm.naml.limit,"total":_vm.Notice.total,"continues":5},on:{"getPageNo":_vm.getPageNo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }